import { RequestThrottledFrame } from "../tfs-utilities";

const SubNav = {
  data: {
    navSelector: ".js-sub-nav",
    classLeft: "tfs-sub-nav--gradient-left",
    classMiddle: "tfs-sub-nav--gradient-both",
    classRight: "tfs-sub-nav--gradient-right"
  },

  init() {
    this.handleHorizontalScroll();
  },

  handleHorizontalScroll() {
    const nav = document.querySelector(this.data.navSelector);
    // document.body.contains() because document.contains() doesn't work in IE
    if (document.body.contains(nav)) {
      this.handleShadowVisibility(nav);
      RequestThrottledFrame("scroll", "optimizedScroll", nav); // register
      nav.addEventListener("optimizedScroll", () => this.handleShadowVisibility(nav));
    }
  },

  // Mobile horizontal scrolling
  handleShadowVisibility(element) {
    const maxScrollStartReached = element.scrollLeft <= 0;
    const maxScrollEndReached = element.scrollLeft >= element.scrollWidth - element.offsetWidth;

    requestAnimationFrame(() => {
      if (maxScrollStartReached && !maxScrollEndReached) {
        // Beginning
        element.classList.remove(this.data.classLeft);
        element.classList.remove(this.data.classMiddle);
        element.classList.add(this.data.classRight);
      } else if (!maxScrollStartReached && !maxScrollEndReached) {
        // Middle
        element.classList.remove(this.data.classLeft);
        element.classList.add(this.data.classMiddle);
        element.classList.remove(this.data.classRight);
      } else if (!maxScrollStartReached && maxScrollEndReached) {
        // End
        element.classList.add(this.data.classLeft);
        element.classList.remove(this.data.classMiddle);
        element.classList.remove(this.data.classRight);
      }
    });
  }
};
export default SubNav;
